/**
 * ルーティング定数
 * @module ~/constants/routes
 */

/** アプリ全体で共通利用するルーティング定数 */
export const ROUTE = {
  RECEPTION: {
    LOADING: "/reception/loading",
    COMPLETE: "/reception/complete",
    ERROR: "/reception/error",
    CALLING: "/reception/calling",
    QR: "/reception/qr",
    COMPANY: "/reception/company",
    MENU: "/reception/menu",
    DELIVERY_COMPANIES_LIST: "/reception/delivery-companies-list",
    DELIVERY_MAP: "/reception/delivery-map",
    INPUT_CODE: "/reception/input-code",
    INPUT_EXTENSION_NUMBER: "/reception/input-extension-number",
    VISITOR_INFO_INPUT: "/reception/visitor-info-input",
    GROUP_LIST: "/reception/group-list",
    SEARCH_USER: "/reception/search-user",
    INTERVIEW: "/reception/interview",
    OTHER: "/reception/other",
    SECRETARY: "/reception/secretary",
    TAXI: "/reception/taxi",
    FACE_RECOGNITION: "/reception/face-recognition",
    CONVERSATION: {
      VISITOR: "/reception/conversation/visitor",
      DEPARTMENT_PIC: "/reception/conversation/department-pic",
      VISITOR_SELECTION: "/reception/conversation/visitor-selection",
      VISITOR_CONFIRMATION: "/reception/conversation/visitor-confirmation",
    },
  },
} as const;
